export default __webpack_public_path__ + "static/media/services_01.6c0864a6.jpg";